import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlug, faPlus } from "@fortawesome/pro-regular-svg-icons";
import { RWA_URLS } from "~/consts";
import { Anchor } from "~/components/Anchor";
import { Button } from "~/components/ui/button";
import { OauthUserEvents } from "~/modules/analytics/events/oauth";
import { McpWizardModalProvider } from "~/modules/mcp/components/McpWizardModalProvider";

// // // //

export function OnboardingEmptyState() {
    return (
        <div className="flex flex-col items-center justify-center rounded-xl border-2 border-dashed p-14 text-center">
            <div className="mb-5 flex size-14 items-center justify-center rounded-full bg-muted">
                <FontAwesomeIcon
                    icon={faPlug}
                    className="size-7 text-muted-foreground"
                />
            </div>
            <h3 className="text-xl font-semibold text-foreground">
                Connect your first MCP client
            </h3>
            <p className="mt-2 max-w-md text-base text-muted-foreground">
                Create an OAuth client to get a client ID and secret, then add
                them to Claude.
            </p>
            <div className="mt-6 flex flex-col items-center gap-3">
                <McpWizardModalProvider>
                    {({ openWizard }) => (
                        <Button
                            size="lg"
                            variant="primaryLight"
                            onClick={() => openWizard("claude")}
                        >
                            <FontAwesomeIcon
                                className="size-4"
                                icon={faPlus}
                                aria-hidden="true"
                            />
                            New Connection
                        </Button>
                    )}
                </McpWizardModalProvider>
                <Anchor
                    href={RWA_URLS.docsMcp}
                    openInNewTab
                    analyticsLabel={OauthUserEvents.ReadMcpSetupDocs}
                    className="text-sm text-link hover:underline"
                >
                    Read the MCP setup docs →
                </Anchor>
            </div>
        </div>
    );
}
